// Helpers for slices that hold a list of records keyed by `id`. They mutate the Immer draft and
// index the list once, so a bulk update stays linear instead of one findIndex per item.

const mergeById = (state, items, appendMissing) => {
  const indexById = new Map(state.map((record, index) => [record?.id, index]));

  for (const item of items || []) {
    const index = indexById.get(item?.id);
    if (index !== undefined) {
      state[index] = item;
    } else if (appendMissing) {
      indexById.set(item?.id, state.length);
      state.push(item);
    }
  }
};

// Replaces the records already in the list and ignores the others
export const replaceById = (state, items) => mergeById(state, items, false);

// Replaces the records already in the list and appends the others, so loading the same records
// twice doesn't duplicate rows
export const upsertById = (state, items) => mergeById(state, items, true);
